import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Card from '../../components/Card/Card';
import Icon from '../../components/Icon/Icon';
import ICONS from '../../components/Icon/IconPaths';

class Settings extends Component {
  render() {
    return (
        <div>
          <h1 className="mt-0 mb-4">Impostazioni</h1>
          <Link to="/settings/account">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Il tuo account</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.ARROW_RIGHT} className="Icon --Green-base" />
              </div>
            </Card>
          </Link>
          <Link to="/settings/gift-subscriptions">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Abbonamenti regalo</h5>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.ARROW_RIGHT} className="Icon --Green-base" />
              </div>
            </Card>
          </Link>
          <Link to="/settings/business">
            <Card className="--Green-base settings my-3 px-4 py-5 px-sm-5 d-flex justify-content-between">
              <div>
                <h5 className="m-0">Abbonamenti aziendali</h5>
                <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
              </div>
              <div className="ml-4">
                <Icon icon={ICONS.ARROW_RIGHT} className="Icon --Green-base" />
              </div>
            </Card>
          </Link>
        </div>
    );
  }
}

export default Settings;